<template>
	<section id="about" class="s-about">
		<div id="about-header" class="row section-header has-bottom-sep" data-aos="fade-up">
			<div class="col-full">
				<h3 class="subhead subhead--dark" v-html="$t('titles.aboutHello')"></h3>
				<h1 class="display-1 display-1--light" v-html="$t('titles.aboutWeAreWOG')"></h1>
			</div>
		</div>

		<div id="about-text" class="row about-desc" data-aos="fade-up">
			<div class="col-full text-left">
				<p class="tt" v-html="$t('texts.aboutParagraph1')"></p>
				<p class="tt" v-html="$t('texts.aboutParagraph2')"></p>
				<ul>
					<li class="tt" v-html="$t('texts.aboutFeature1')"></li>
					<li class="tt" v-html="$t('texts.aboutFeature2')"></li>
					<li class="tt" v-html="$t('texts.aboutFeature3')"></li>
					<li class="tt" v-html="$t('texts.aboutFeature4')"></li>
				</ul>
				<p class="tt" v-html="$t('texts.aboutParagraph3')"></p>
			</div>
		</div>

		<WidgetFeatures/>

		<div class="about__line"></div>
	</section>
</template>

<script>
	import WidgetFeatures from '../widgets/Features';
	export default {
		name: 'SectionAbout',
		components: {WidgetFeatures}
	}
</script>


// WEBPACK FOOTER //
// src/components/sections/About.vue